import cn from "classnames"
import React, { useState } from "react"
import { Input, InputProps, Label } from "reactstrap"
import FieldsetFormGroup from "./../FieldsetFormGroup"
import "./FormGroupWithCheckbox.scss"

interface IFormGroupWithCheckboxProps extends InputProps {
    title?: string
    className?: string
    validationError?: string
    hint?: string
}

const FormGroupWithCheckbox = ({
    title,
    children,
    className,
    validationError,
    hint,
    ...otherProps
}: IFormGroupWithCheckboxProps) => {
    const [showHint, setShowHint] = useState(false)

    return (
        <FieldsetFormGroup forCheckbox className={className}>
            <Label check style={{ cursor: "pointer" }}>
                <Input
                    className="swiipe-checkbox"
                    style={{ cursor: "pointer" }}
                    onInvalid={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (validationError) e.target.setCustomValidity(validationError)
                    }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (validationError) e.target.setCustomValidity("")
                    }}
                    type="checkbox"
                    {...otherProps}
                />
                {title}
                {children}
                {hint && (
                    <div className="checkbox-hint-container-admin">
                        <span
                            className="icon hint-icon"
                            onClick={(e) => {
                                e.preventDefault()
                                setShowHint(!showHint)
                            }}
                            onMouseOut={() => {
                                setShowHint(false)
                            }}
                            onTouchStart={() => {
                                setShowHint(true)
                            }}
                            onTouchEnd={() => {
                                setShowHint(false)
                            }}
                        ></span>
                        <span className={cn("hint-text", { "d-none": !showHint })}>{hint}</span>
                    </div>
                )}
            </Label>
        </FieldsetFormGroup>
    )
}

export default FormGroupWithCheckbox
